import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(16, '2%', 16, 34),
    gap: spacing(16),
  },
  headerInfo: {
    height: 72,
    width: '100%',
    padding: spacing(16, '2%', 16, 34),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
}))
